import { Component } from 'react';
import AMS from '@ui/components/ams';
import { termsAndConditionsPageQuery } from '@queries/pages/termsAndConditions';
import { withServerSideProps } from '@lib/withServerSideProps';
import Page from '@ui/components/ams/Pages/Page';

class TermsAndConditionsPage extends Component {
  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
    } = this.props;

    const {
      termsAndConditions = {},
    } = pageData;

    const {
      pageTitle = '',
      metaDescription,
    } = termsAndConditions;

    return (
      <Page
        pageTitle={pageTitle}
        metaDescription={metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.TermsAndConditionsContent
          termsAndConditionsPageData={termsAndConditions}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: termsAndConditionsPageQuery,
});

export default TermsAndConditionsPage;
